<template>
  <section class="selftests">
    <div class="response_table">
      <table>
        <thead>
          <tr>
            <th scope="col"> {{ translate("factorytest_list.id") }} </th>
            <th scope="col"> {{ translate("factorytest_list.username") }} </th>
            <th scope="col"> {{ translate("factorytest_list.client_order") }} </th>
            <th scope="col"> {{ translate("factorytest_list.ts") }} </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(elem_test, elem_test_key) in factorytest_list" :key="elem_test_key" @click="show_modal(elem_test)">
            <td :data-label="translate('factorytest_list.id')" >
              {{elem_test.id}}
            </td>
            <td :data-label="translate('factorytest_list.username')" >
              <router-link :to="'/user/' + elem_test.user_id">
                {{elem_test.user_name}}
              </router-link>
            </td>
            <td :data-label="translate('factorytest_list.client_order')" >
              <router-link :to="'/client_order/' + elem_test.client_order_id">
                {{elem_test.client_order_name}}
              </router-link>
            </td>
            <td :data-label="translate('factorytest_list.ts')" >
              {{get_date(elem_test.ts)}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import FactoryTestModal from './Modal/Index.vue'

export default {
  name: 'FactoryTestList',
  props: ['device_id'],

  data(){
    return {
      factorytest_list:{},
      check_link: true,
    }
  },
  created() {
    this.init()
  },
  methods: {
    check_factorytest() {
      if (this.$route.query.factorytest_id) {
        this.factorytest_list.forEach((factorytest_item) => {
          if (factorytest_item.id === Number(this.$route.query.factorytest_id)){
            this.show_factorytest(factorytest_item);
          }
        })
      }
    },
    show_factorytest(val) {
      if (this.$route.params.device_section === "testing") {
        if (this.check_link) {
          this.check_link = false;
          this.show_modal(val);
        }
      }
    },
    show_modal(data){
      let t = this.$createElement(FactoryTestModal, {
        props: {
          data
        },
        on: {
          close: () => {
            this.$modal.hide('factory_test_modal')
            this.check_link = true;
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'factory_test_modal'})
    },
    init(){
      this.$http.v1.getDeviceFactoryList( {device_id: this.device_id}, (response) => {
        this.factorytest_list = response.data.factorytest_list
        this.check_factorytest()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  section.selftests{
    display: flex;
    .response_table{
      padding: 0;
      .title{
        text-align: center;
        margin-top: 10px;
      }
      th{
        font-size: 12px;
      }
      tbody{
        tr{
          cursor: pointer;
          font-size: 12px;
          &:hover{
            background-color: #f1f1f1;
          }
        }
      }
    }
  }
</style>
